"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonSearchIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var PersonSearch = function PersonSearch(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.5 11.5c-2.068 0-3.75-1.682-3.75-3.75S8.432 4 10.5 4s3.75 1.682 3.75 3.75-1.682 3.75-3.75 3.75zm0-6.5C8.984 5 7.75 6.234 7.75 7.75s1.234 2.75 2.75 2.75 2.75-1.234 2.75-2.75S12.016 5 10.5 5zm5.056 11.5a.502.502 0 01-.47-.329 4.787 4.787 0 00-2.493-2.72 4.77 4.77 0 00-2.034-.454 4.835 4.835 0 00-4.533 3.174.5.5 0 01-.94-.342 5.811 5.811 0 013.478-3.479 5.774 5.774 0 014.451.194 5.785 5.785 0 013.01 3.285.499.499 0 01-.469.671z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.5 24a.5.5 0 01-.354-.146l-5.589-5.589A10.443 10.443 0 0110.5 21C4.71 21 0 16.29 0 10.5S4.71 0 10.5 0 21 4.71 21 10.5c0 2.621-.969 5.117-2.736 7.057l5.589 5.589A.5.5 0 0123.5 24zm-13-23C5.262 1 1 5.262 1 10.5S5.262 20 10.5 20s9.5-4.262 9.5-9.5S15.738 1 10.5 1z"
  }));
};
PersonSearch.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const PersonSearchIcon = exports.PersonSearchIcon = (0, _createIconComponent.default)(PersonSearch, 'PersonSearch');